<template>
    <div v-shortkey="{quotation: ['alt','q'], order: ['alt','o'], sale: ['alt','v'], payment: ['alt','t'], credit: ['alt','i']}" @shortkey="onKeyEvent">
        <v-speed-dial v-model="fab"
                      bottom right
                      direction="left"
                      open-on-hover
                      transition="scale-transition">
            <template v-slot:activator>
                <v-btn v-model="fab"
                       color="blue darken-2"
                       dark
                       fab>
                    <v-icon v-if="fab">mdi-close</v-icon>
                    <v-icon v-else>visibility</v-icon>
                </v-btn>
            </template>
            <v-btn dark rounded small
                   color="green" @click="quotation" >
                <v-icon left>mdi-plus</v-icon> COTIZACION
            </v-btn>
            <v-btn dark rounded small
                   color="indigo" @click="order" >
                <v-icon left>mdi-plus</v-icon> ORDEN
            </v-btn>
            <v-btn dark rounded small
                   color="blue" @click="sale" >
                <v-icon left>mdi-plus</v-icon> VENTA
            </v-btn>
            <v-btn dark rounded small
                   color="indigo" @click="payment">
                <v-icon left>mdi-plus</v-icon> PAGO
            </v-btn>
            <v-btn dark rounded small
                   color="cyan" @click="credit" >
                <v-icon left>mdi-plus</v-icon> NOTA CREDITO
            </v-btn>
        </v-speed-dial>
    </div>
</template>

<script>
    export default {
        name: 'quick-button',
        data: () => ({
            fab: false,            
        }),

        computed: {
            
        },

        watch: {
            
        },

        methods: {
            redirectRoute(route) {
                let routerObj = {};
                routerObj.name = route;
                routerObj.query = { create: true };
                this.$router.push(routerObj);
            },

            quotation() {
                this.$store.commit('quotation/new');
                this.redirectRoute('quotation');
            },
            order() {
                this.$store.commit('order/new');
                this.redirectRoute('sale-order');
            },
            sale() {
                this.$store.commit('sale/new');
                this.redirectRoute('sale');
            },
            payment() {
                this.$store.commit('payment/new');
                this.redirectRoute('payment');
            },
            credit() {
                this.$store.commit('creditnote/new');
                this.redirectRoute('credit-note');
            },

            onKeyEvent(event) {
                switch (event.srcKey) {
                    case 'quotation':
                        this.quotation();
                        break
                    case 'order':
                        this.order();
                        break
                    case 'sale':
                        this.sale();
                        break
                    case 'payment':
                        this.payment();
                        break
                    case 'credit':
                        this.credit();
                        break
                }
            }
        }
    }
</script>
<style>
    /* This is for documentation purposes and will not be needed in your application */
    .v-speed-dial {
        position: fixed !important;
    }
    .v-speed-dial--right {
        right: 20px !important;
        width: 56px;
    }
    .v-speed-dial--bottom {
        bottom: 50px !important;
    }
    
</style>